import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete, Chip } from '@mui/material';
import ObtenerServicios from '../functions/ObtenerServicios';
import ObtenerServiciosPlanes from '../functions/ObtenerServiciosPlanes';
import ServiciosSeleccionar from '../types/ServiciosSeleccionar';
import PlanServiciosSeleccionar from '../types/PlanServiciosSeleccionar';

interface SeleccionarServiciosProps {
    elPlan: PlanServiciosSeleccionar;
    onChange: (servicio: ServiciosSeleccionar) => void;
    onRemove: (servicio: ServiciosSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarServicios: React.FC<SeleccionarServiciosProps> = ({ elPlan, onChange, onRemove, onClear, eliminando }) => {

    const [plan, setPlan] = useState<PlanServiciosSeleccionar>({id: 0, title: '', servicios: []});
    const [servicios, setServicios] = useState<ServiciosSeleccionar[]>([]);

    const fetchDatosIniciales = async () => {
        
        // Recupero los datos de los servicios para mostrarlos en el autocomplete
        const dataServicios = await ObtenerServicios("activos");
        if (dataServicios.servicios_ok === 'si') {

            const serviciosRecuperados: ServiciosSeleccionar[] = [];
            for (const servicio of dataServicios.servicios) {
                serviciosRecuperados.push({
                    id: servicio.id,
                    nombre: servicio.nombre
                });
            }

            setServicios(serviciosRecuperados);
            
            if (elPlan.id > 0) {
                
                setPlan(elPlan);
            }
        }
    };

    const onChangeLocal = (servicio: ServiciosSeleccionar) => {
        // Need to update the servicios array with the new servicio
        const serviciosCopy = [...plan.servicios];
        serviciosCopy.push(servicio);
        setPlan({
            ...plan,
            servicios: serviciosCopy
        });
        onChange(servicio);
    }

    const onRemoveLocal = (servicio: ServiciosSeleccionar) => {
        // Need to update the servicios array removing the servicio
        const serviciosCopy = plan.servicios.filter((item) => item.id !== servicio.id);
        setPlan({
            ...plan,
            servicios: serviciosCopy
        });
        onRemove(servicio);
    }

    const onClearLocal = () => {
        setPlan({
            ...plan,
            servicios: []
        });
        onClear();
    };

    useEffect(() => {
        fetchDatosIniciales()
    }, []);

    /*useEffect(() => {
        fetchRubros()
    }, [rubroInicial]);*/

    return (
        <div className="flex flex-col w-full">
            <Autocomplete
                multiple
                id="servicios"
                size="small"
                options={[...servicios].sort((a, b) =>
                    a.nombre.localeCompare(b.nombre)
                )}
                getOptionLabel={(option) => option.nombre}
                value={plan.servicios}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue, reason, details) => {
                    if (reason === 'selectOption') {
                        if (details?.option) {
                            onChangeLocal(details.option);
                        }
                    } else if (reason === 'removeOption') {
                        if (details?.option) {
                            onRemoveLocal(details.option);
                        }
                    } else if (reason === 'clear') {
                        onClearLocal();
                        onClear();
                    }
                }}
                renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                        <Chip
                            key={key}
                            variant="filled"
                            label={option.nombre}
                            size="small"
                            {...tagProps}
                        />
                    );
                })
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Servicios del plan"
                        placeholder="Servicios del plan"
                    />
                )}
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarServicios;